export default __webpack_public_path__ + "assets/64a0494c8180363b7aed002b2521598f.svg";